'use client';

import type { NavigationComponentProps } from '@carvana/merch-tile';
import { useTriggerVdpNavigation } from '~/context/common/VdpNavigationContext';
import {
  isMiddleClick,
  isOpenInNewTabClick
} from '~/utilities/isOpenInNewTabClick';
import NavigationLink from './NavigationLink';

type OwnProps = NavigationComponentProps & { 'data-testid'?: string };

export default function SpaNavigationLink({
  'data-testid': dataTestId,
  onClick,
  ...props
}: OwnProps) {
  const triggerVdpNavigation = useTriggerVdpNavigation();

  // onClick catches ctrl/cmd/shift+click (isOpenInNewTabClick), which still fire click.
  // onAuxClick catches middle-click, which never fires click at all.
  // Both open the VDP in a new tab/window, so neither should trigger the SPA skeleton.
  function handleClick(e: React.MouseEvent<HTMLAnchorElement>) {
    if (!isOpenInNewTabClick(e)) {
      triggerVdpNavigation();
    }

    onClick?.(e);
  }

  function handleAuxClick(e: React.MouseEvent<HTMLAnchorElement>) {
    if (isMiddleClick(e)) return;

    triggerVdpNavigation();
  }

  return (
    <NavigationLink
      {...props}
      data-testid={dataTestId}
      onAuxClick={handleAuxClick}
      onClick={handleClick}
    />
  );
}
